export default function TenderStatus({ status }) {
  let colorClasses = "";
  switch (status) {
    case "open":
      colorClasses = "text-purple-800 border-purple-300";
      break;
    case "closed":
    case "cancelled":
    case "no_award":
      colorClasses = "text-gray-800 border-gray-300";
      break;
    case "pending_award":
      colorClasses = "text-white border-yellow-800 bg-yellow-800";
      break;
    case "awarded":
      colorClasses = "text-white border-purple-800 bg-purple-800";
      break;
    default:
      colorClasses = "text-purple-800 border-purple-300";
      break;
  }
  return (
    <div
      className={`rounded-full px-6 py-1 text-sm font-semibold border ${colorClasses}`}
    >
      {status.toUpperCase()}
    </div>
  );
}
